import { useRef, useState, useLayoutEffect } from "react";

const useStickyAction = (dependency) => {
    const tableWrapperRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useLayoutEffect(() => {
        const el = tableWrapperRef.current;
        if (!el) return;

        const checkOverflow = () => {
            setIsOverflowing(el.scrollWidth > el.clientWidth);
        };

        checkOverflow();

        const resizeObserver = new ResizeObserver(checkOverflow);
        resizeObserver.observe(el);

        window.addEventListener("resize", checkOverflow);

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener("resize", checkOverflow);
        };
    }, [dependency]);

    return { tableWrapperRef, isOverflowing };
};

export default useStickyAction;